<template>
  <CarouselList
    :title="$t('tong-zu-yi-tui-jian')"
    :total="digitalHumanList?.length || 0"
  >
    <SwiperSlide v-for="template in digitalHumanList" :key="template.id">
      <ContentCharacterCard
        :key="template.id"
        :data="template"
        class="h-[366px]"
        target="_blank"
        @change="onChange($event, template)"
      />
    </SwiperSlide>
  </CarouselList>
</template>
<script lang="ts" setup>
import { SwiperSlide } from 'swiper/vue'
import CarouselList from '../carousel-list.vue'
import Empty from '../empty.vue'
import type { Character } from '~/api/interface/character'

interface CommonScenariosProps {
  digitalHumanList?: Character[]
}

const props = defineProps<CommonScenariosProps>()

provideResourceLocation({
  source: SOURCE.CHARACTER_DETAIL_COMMON_RACE,
})

const onChange = ([key, value]: [string, Character], data: Character) => {
  const item: any = props.digitalHumanList?.find((item) => item.id === data.id)
  if (item) {
    item[key] = value
  }
}
</script>
<style lang="scss" scoped></style>
